export interface IUser {
  company: string;
  country: string;
  cluster: string;
  email: string;
  username: string;
  termsAgreed: boolean;
  verified: boolean;
  roles: string[];
  dateCreated: string;
  dateUpdated: string;
  organisationId: number;
}

export interface DevPortalUser {
  company?: string;
  country: string;
  email: string;
  username: string;
  cluster: string;
  termsAgreed: boolean;
  verified: boolean;
  roles: string[];
  dateCreated: string;
  dateUpdated: string;
  organisationId: number;
}

export interface DevPortalTestingAccount {
  username: string;
  cluster: string;
  organisationId: number;
  dateCreated: string;
  dateUpdated: string;
  email: string;
  password: string;
  hatActive: boolean;
}
export interface ApiDevPortalUser {
  company?: string;
  firstName: string;
  lastName: string;
  country?: string;
  email: string;
  username?: string;
  cluster?: string;
  termsAgreed: boolean;
}

export enum USER_FILTER {
  NAME = 'name',
  UPDATED = 'updated',
  EMPTY = '',
}
